module.exports = __webpack_public_path__ + "img/5.95e6ae0c.png";